import { createSlice } from "@reduxjs/toolkit";
import {
  ClientExternalData,
  ClientInfo,
} from "../../types/clients-module-types";
import { HUBSPOT } from "../../../SharedModule/utils/constants";

type ClientDetailsState = {
  isClientDetailInfoLoading: boolean;
  isClientDetailInfoLoaded: boolean;
  generalActualClientId: number | null;
  clientDetails: ClientInfo | null;
  actualClientExternalData: ClientExternalData | null;
  needClientInfoUpdate: boolean;
};

const initialState: ClientDetailsState = {
  isClientDetailInfoLoading: false,
  isClientDetailInfoLoaded: false,
  generalActualClientId: null,
  clientDetails: null,
  actualClientExternalData: null,
  needClientInfoUpdate: false,
};

export const clientDetailsSlice = createSlice({
  name: "clientDetails",
  initialState,
  reducers: {
    loadClientDetails: (state, action) => {
      state.actualClientExternalData =
        action.payload.data.clientExternalData.find(
          (e: ClientExternalData) => e.systemName === HUBSPOT
        );
      state.clientDetails = action.payload.data.client;
      state.isClientDetailInfoLoading = false;
      state.isClientDetailInfoLoaded = true;
      state.needClientInfoUpdate = false;
    },
    setIsClientDetailInfoLoading: (state, action) => {
      state.isClientDetailInfoLoading = action.payload;
    },
    setIsClientDetailInfoLoaded: (state, action) => {
      state.isClientDetailInfoLoaded = action.payload;
    },
    setNeedClientInfoUpdate: (state, action) => {
      state.needClientInfoUpdate = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  loadClientDetails,
  setIsClientDetailInfoLoading,
  setIsClientDetailInfoLoaded,
  setNeedClientInfoUpdate,
} = clientDetailsSlice.actions;

export const IsClientDetailInfoLoading = (state: any) => {
  return state.clientDetails.isClientDetailInfoLoading;
};

export const IsClientDetailInfoLoaded = (state: any) => {
  return state.clientDetails.isClientDetailInfoLoaded;
};

export const SelectClientDetails = (state: any) => {
  return state.clientDetails.clientDetails;
};

export const SelectActualClientExternalData = (state: any) => {
  return state.clientDetails.actualClientExternalData;
};

export const SelectNeedClientInfoUpdate = (state: any) => {
  return state.clientDetails.needClientInfoUpdate;
};

export default clientDetailsSlice.reducer;
